<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g opacity="0.3">
							<path
								d="M8.33331 4.94141L7.08331 6.19141L10.8919 10L7.08331 13.8086L8.33331 15.0586L13.3919 10L8.33331 4.94141Z"
								fill="currentColor" />
						</g>
					</svg>
</template>